var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRunStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.28583 8.66659V1.33325L12.6192 3.99992L7.28583 6.66659",
    stroke: "#A6AFCE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.9931 6.81451C13.3479 7.90793 13.3811 9.08026 13.0888 10.192C12.7964 11.3038 12.1909 12.3081 11.3442 13.0856C10.4975 13.8631 9.44521 14.381 8.31262 14.5777C7.18004 14.7744 6.01478 14.6416 4.9555 14.1951C3.89622 13.7486 2.9875 13.0072 2.33746 12.0591C1.68741 11.111 1.3234 9.99614 1.28874 8.84713C1.25408 7.69811 1.55022 6.56332 2.14193 5.57777C2.73365 4.59221 3.59602 3.79738 4.62646 3.28784",
    stroke: "#A6AFCE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.62047 6.66455C4.2864 7.10923 4.06892 7.63044 3.98783 8.18068C3.90674 8.73092 3.96462 9.2927 4.1562 9.81485C4.34778 10.337 4.66697 10.8029 5.08468 11.1701C5.5024 11.5374 6.00537 11.7942 6.54775 11.9173C7.09014 12.0404 7.65471 12.0259 8.19003 11.8749C8.72535 11.724 9.21439 11.4416 9.61261 11.0533C10.0108 10.665 10.3056 10.1832 10.4699 9.6519C10.6343 9.12057 10.6632 8.55654 10.5538 8.01122",
    stroke: "#A6AFCE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRunStatus);
export default __webpack_public_path__ + "static/media/run-status.1d4e2478ebe54c21f9bbffd6e699dcf8.svg";
export { ForwardRef as ReactComponent };